import {Component, Input, OnChanges, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {IOuterNode} from './interfaces/IOuterNode';
import {IContextMenu} from './interfaces/IContextMenu';
import {TreeModel} from './models/TreeModel';
import {Store} from '@ngrx/store';
import {ITreeState} from './store/ITreeState';
import {filter} from 'rxjs/operators';
import {
  TreeDeleteNodeAction,
  TreeEditNodeStartAction,
  TreeInsertNodeAction,
  TreeMoveNodeAction
} from './store/treeActions.service';
import {Observable, Subscription} from 'rxjs';

@Component({
    standalone: false,
  encapsulation: ViewEncapsulation.None,
  selector: 'ri-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.less']
})
export class TreeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() treeModel: TreeModel;

  /**
   * List of default options for context menu
   */
  public defaultOptions: IContextMenu[] = [
    {
      name: 'onEdit',
      text: 'RI_TREE_LBL_EDIT_NODE',
      iconCls: 'fa fa-edit'
    },
    {
      name: 'onDelete',
      text: 'RI_TREE_LBL_REMOVE_NODE',
      iconCls: 'fa fa-trash'
    }
  ];

  /**
   * List of context menu items
   */
  public menuList: IContextMenu[] = [];

  public rootNodes$: Observable<IOuterNode[]>;

  protected currentSelectedNode: IOuterNode;

  protected subscription = new Subscription();

  public constructor(protected store: Store<ITreeState>) {

  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public ngOnInit() {

    this.rootNodes$ = this.treeModel.rootNodes$;

    this.subscription.add(
      this.treeModel.currentSelectedNode$
        .subscribe((node: IOuterNode) => this.currentSelectedNode = node)
    );
  }

  public ngOnChanges(data: any) {
    this.menuList = [];
    this.defaultOptions.forEach((item) => this.menuList.push(item));
  }

  public onAdd() {
    const parentId = this.currentSelectedNode ? this.currentSelectedNode.id : null;

    this.store.dispatch(new TreeInsertNodeAction({treeId: this.treeModel.treeId, parentId}));
  }

  /**
   * On select item from context menu
   *
   * @param name - name of the event
   * @param node - data item
   */
  public onContextMenuClick(name: string, node: IOuterNode) {

    switch (name) {
      case 'onEdit':
        event.stopPropagation();
        this.store.dispatch(new TreeEditNodeStartAction({node}));
        break;
      case 'onDelete':
        this.store.dispatch(new TreeDeleteNodeAction({treeId: this.treeModel.treeId, node}));
        break;
      default:
        console.warn('Unknown context menu action: ' + name);
    }
  }

  public trackByFn(item: IOuterNode): string {
    return item.id;
  }

}
